import { ReactSVG } from "react-svg";
import styles from "./how_attend.module.scss";

const VFairHowAttend = () => {
  return (
    <section className={styles.how_attend_section}>
      <div className="container">
        <div className={styles.how_attend_wrapper}>
          <div className={styles.how_attend_text}>
            <h2>
              How To <span className="color-orange"> Attend?</span>{" "}
            </h2>
          </div>
          <div className={styles.step_parent}>
            <div className={styles.steps_wrapper}>
              <div>
                <div>
                  <ReactSVG
                    src="/assets/icons/step-one.svg"
                    className={styles.icons}
                  />
                </div>

                <div className={styles.steps_text}>
                  <h3>Step 1</h3>
                  <p>Register for UniConnect by creating an account</p>
                </div>
              </div>
              <div>
                <ReactSVG
                  src="/assets/icons/step-two.svg"
                  className={styles.icons}
                />
                <div className={styles.steps_text}>
                  <h3>Step 2</h3>
                  <p>
                    Complete your profile to view the recommended universities
                  </p>
                </div>
              </div>
              <div>
                <ReactSVG
                  src="/assets/icons/step-three.svg"
                  className={styles.icons}
                />
                <div className={styles.steps_text}>
                  <h3>Step 3</h3>
                  <p>
                    Visit university booths and interact with university experts
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.border}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VFairHowAttend;
